const ja = {
	certification: {
		verification: '実名情報',
		updateHistory: '変更履歴',
		certificateRequired: '証明書期限リマインダー',
		changeIdentites: '法人、株主、受益者の変更',
		changePerson: '法人、株主、受益者の変更',
		completeIdentityVerification: '本人確認（KYC）情報の入力',
		verificationTips: '関連する規制機関の要件に従い、アカウントのセキュリティを確保するために、PingPong はユーザーの実際の身元情報を収集し、それを確認する必要があります。',
		verificationTips2nd: 'PingPong は、お客様が提供する実名情報を極秘に保つことを約束します。',
		imgUploadTips: '画像のアップロード要件: 必ずご確認ください',
		imgUploadTips2nd: '写真情報が明確に表示されるため、承認時間が短縮されます',
		imgUploadTips3rd: '最大サイズは 10M を超えず、形式は JPG、JPEG、PNG、BMP に限定されます。',
		imgExample: 'サンプル画像を見る',
		auditReport: '監査報告書',
		writeCompany: '会社情報を入力してください',
		writeLegal: '法人情報を入力してください',
		writeDirector: '株主情報を入力してください',
		writeDirector2: 'ディレクター情報を入力してください',
		writeBeneficiary: '受取人情報を入力してください',
		uploadDesc: '承認時間を短縮するために、写真情報が明確に見えるようにしてください。'
	},
	photoTips: {
		correct: '正しい仕様:',
		error: 'エラーの例:',
		specification1: '四隅すべてが完全に表示される必要があります',
		specification2: '均一な明るさと無反射性',
		specification3: '内容が明確で可読性が高い',
		example1: '写真が不完全です',
		example2: '写真がぼやけています',
		example3: '写真の反射率が高い'
	},
	review: {
		messageTip: 'あなたの本名情報は審査中です。しばらくお待ちください。',
		messageReSubmit: '送信した実名認証は、データが欠落しているか情報が間違っているため、審査に失敗しました。再提出してください。',
		approved: 'あなたの本名情報は審査され、承認されました',
		uneligible: '残念ながら、現在あなたには資格がありません。'
	},
	add: {
		applicantsIdentity: '法人情報 申請者の身元',
		informationofApplicant: '法人情報をご入力ください',
		addApplicantIdentity: '法定代表者を追加',
		shareholderIdentity: '株主情報 取締役の略歴',
		shareholderIdentity2: '役員の本人確認情報',
		informationofshareholder: '会社の株主全員の情報を入力してください',
		informationofshareholder2: '会社の取締役全員の情報を入力してください',
		addashareholder: '株主を追加する',
		addashareholder2: '役員を追加',
		BeneficiaryIdentity: '実質的支配者の本人確認情報',
		informationofBeneficiary: '株式の 25% 以上を保有する自然人株主の情報を入力してください',
		informationofBeneficiary2: '株式の 25% 以上を保有する自然人の取締役の情報を入力してください',
		addabeneficiary: '実質的支配者を追加',
		goBack: '前のステップに戻る',
		saveAndNext: '保存して次のステップに進みます',
		submitwebsite: 'ウェブサイトを送信して追加する',
		submitVerification: '実名情報を送信する',
		save: '一時保存',
		deleted: '正常に削除されました',
		deleteFailed: '削除に失敗しました',
		tryAgain: 'もう一度試してください',
		pic: '画像を追加',
		uploadFile: 'ファイルアップロード',
		reupload: '再アップロード',
		uploadSuccess: 'ファイルが正常にアップロードされました',
		notice: '確認',
		uploadFileNotice: 'アップロードするファイルのサイズは以下を超えることはできません',
		imgLimited: '画像は JPG、JPEG、PNG、BMP 形式である必要があります',
		pictureFormatError: '画像フォーマットエラー',
		picUploadSuccess: '画像が正常にアップロードされました',
		uploadMethods: 'アップロード方法を選択してください',
		PleaseUploadInformation: '情報をアップロードしてください',
		uploadFailed: '画像のアップロードに失敗しました。もう一度アップロードしてください',
		uploadLimited: '画像は JPG、JPEG、PNG、BMP 形式である必要があります',
		uploadagain: '元の画像を削除して再アップロードしてください',
		uploadPic1st: 'アップロードのみ可能',
		uploadPic2nd: '画像ファイル',
		reupload2: '画像のアップロードに失敗しました',
		choose: '選択'
	},
	company: {
		businessInformation: '会社情報 事業案内',
		businessLocation: '登記国 / 地域',
		nationality: '登記国 / 地域',
		select: '選択してください',
		china: '中国本土',
		hongkong: '香港、中国',
		europe: 'ヨーロッパ',
		america: 'アメリカ',
		africa: 'アフリカ',
		oceania: 'オセアニア',
		asia: 'アジア',
		usa: 'アメリカ合衆国',
		companyNameChinese: '会社名（中国語）',
		companyNameEnglish: '会社名（英語）',
		businessCityChinese: '市区町村',
		businessAddressChinese: '詳細住所（中国語）',
		businessCityEnglish: '都市 (英語)',
		businessAddressEnglish: '詳細住所（英語）',
		postCode: '郵便番号',
		businessType: '法人種別',
		soleProprietorship: '個人事業主',
		companyLimited: '有限会社',
		jointVentureCompany: '合弁事業',
		listedCompany: '上場企業',
		corporationOrganization: '会社・法人・団体',
		others: 'その他',
		businessIdentityNumber: '法人番号',
		businessEstablishedDate: '営業許可発効日',
		businessExpirationDate: '営業許可の有効期限',
		governmentIssuedBusinessCertification: 'ビジネスライセンスの写真',
		HKBusinessRegistrationOrdinance: 'ビジネス登録証明書',
		businessRegistrationOrdinanceExpirationDate: '会社登録時期',
		hkBusinessRegistrationOrdinanceEffectDate: 'ビジネス登録証明書の発効日',
		hkBusinessRegistrationOrdinanceExpirationDate: '事業者登録証明書の有効期限',
		selectTheDate: '日付を選択してください',
		longTermEffective: '長期有効',
		certificateofIncorporation: '登記簿謄本',
		hkCertificateofIncorporation: '会社設立証明書',
		certificateofIncorporationNumber: '法人番号',
		hkCertificateofIncorporationNumber: '会社登録番号',
		certificateofIncorporationEstablishedDate: '設立年月日',
		certificateofIncorporationExpireDate: '有効期限',
		bankAccountInformation: '銀行口座開設許可証 または 基本預金口座情報',
		bankAccountInformationTip: '銀行口座開設ライセンスまたは基本的な預金口座情報をアップロードしてください',
		picture: '画像ファイル',
		EXCEL: 'EXCELファイル',
		pdf: 'PDFファイル',
		officePhotos: 'オフィスの画像',
		tokenofficePhotos: '※オフィス環境や受付の画像を2～5枚アップロードしてください。会社名またはロゴが確認できる必要があります。',
		submitSelect: '次の 2 つの項目のうち少なくとも 1 つを選択して送信してください',
		billOrcontract: '会社のオフィス賃貸契約書または会社の公共料金請求書 (公共料金請求書にはオフィスの住所を記入してください)',
		companyCharter: '定款（バーチャル口座の申請が必要な場合はアップロードしてください）',
		companyCharterDesc: '※本人確認（KYC）通過後に本資料を追加する場合は、[出金口座]よりバーチャル口座を申請してください。',
		'united-states': 'アメリカ合衆国'
	},
	example: {
		checkImageExamples: '画像例',
		uploadTip: '画像をアップロードするための要件: アップロードする情報画像のテキストがはっきりと見えること、最大サイズが 10M を超えないこと、形式が JPG、JPEG、PNG、BMP、PDF に制限されていることを確認してください。',
		IDCardExample: 'IDカードの例',
		businessLicense: '営業許可',
		frontofIDCard: '身分証明書の顔写真',
		backofIDCard: 'IDカードバッジの写真',
		businessIdentity: '営業許可証',
		hongkongId: '香港のIDカード',
		additionalInformation: '追加情報',
		provideInfo: 'あなたの会社をより深く理解できるよう、あなたの会社に関連する追加の高品質な資料を提供していただけます。取締役の住所証明、IRS EIN 証明書、個人 SSN などの情報。',
		uploadMethod: 'アップロード方法',
		passport: 'パスポートのホームページ',
		travelPermit: '本土トラベルパスの写真',
		otherPhoto: 'その他の写真'
	},
	rules: {
		bankAccountInfo: '銀行口座開設ライセンスまたは基本的な預金口座情報をアップロードしてください',
		proofFlow: '取引証明書をアップロードしてください',
		registeredCompany: '会社が登録されている国または地域を選択してください',
		companyChineseName: '会社の中国語名を入力してください',
		companyEnglishName: '会社の英語名を入力してください',
		chooseCity: '都市を選択してください',
		companyChineseAddress: '会社の中国の住所を入力してください',
		companyEnglishAddress: '会社の英語の住所を入力してください',
		companyEnglishCity: '英語の都市を入力してください',
		companyEnglishAddressValid: '有効な情報を入力してください',
		postCode: '郵便番号を入力してください',
		postCodeValid: '英語と数字のみが使用できます',
		businessIdentityNumber: 'ビジネスライセンス番号を入力してください',
		certificateEstablishedDate: '会社登録時間を選択してください',
		bussinessEstablishedDate: 'ビジネスライセンスの発効日を選択してください',
		companyExpiredDate: '会社登記証明書の有効期限を選択してください',
		governmentBussinessCertification: '営業許可証の写真をアップロードしてください',
		HKgovernmentBussinessCertification: 'ビジネス登録証明書の写真をアップロードしてください',
		governmentBussinessCertification2: '会社登記証明書の写真をアップロードしてください',
		applicationForm: '販売者申請フォームをアップロードしてください',
		websiteCertificate: 'ウェブサイトのドメイン名登録証明書をアップロードしてください',
		billOrlease: '会社のオフィス賃貸契約書または会社の公共料金請求書をアップロードしてください',
		addedUser: '登録済みの担当者を選択',
		IDType: '文書の種類',
		IDCardNumber: 'ID番号',
		IDNumber: 'ID番号',
		IDIssueDate: '有効期間（開始）',
		IDExpirationDate: '有効期限',
		legal: '法人',
		director: '株主',
		director2: '監督の名前',
		beneficial: '受益者',
		legalIDCardUpdate: '法人身分証明書の更新',
		directorIDCardUpdate: '株主本人確認書類の更新',
		directorIDCardUpdate2: 'ディレクターの身分証明書の更新',
		beneficialIDCardUpdate: '受取人IDの更新',
		legalInfoUpdate: '法人情報更新',
		directorInfoUpdate: '株主情報の更新',
		directorInfoUpdate2: '役員情報更新',
		beneficialInfoUpdate: '受取人情報更新',
		companyUpdate: '会社証明書の更新',
		legalChange: '法人を変更する',
		directorChange: '株主変更',
		beneficialChange: '受取人の変更',
		fullName: '名前',
		fullNameEN: '英語名',
		firstNameEN: '英語での名前',
		lastNameEN: '姓 英語',
		fullShareholderName: '株主名',
		fullShareholderName2: '監督の名前',
		fullShareholderNameEN: '株主名 英語',
		firstShareholderNameEN: '株主名 英語',
		lastShareholderNameEN: '株主の姓（英語）',
		fullShareholderNameEN2: '監督名 英語',
		firstShareholderNameEN2: '取締役名 英語',
		lastShareholderNameEN2: 'ディレクターの姓（英語）',
		fullBeneficiaryName: '受取人名',
		fullBeneficiaryNameEN: '受取人名 英語',
		firstBeneficiaryNameEN: '受取人名 英語',
		lastBeneficiaryNameEN: '受取人の姓 英語',
		halfName: '名前',
		sameInId: '証明書のピンインと同じ',
		phoneNumber: '電話番号',
		emailAddress: 'メールアドレス',
		DOB: '生年月日',
		nationality: '住宅街',
		addressChinese: '中国の居住住所',
		ConsistentWithid: '証明書の住所と一致するようにしてください',
		addressEnglish: '英語の住居住所',
		save: '保存',
		submit: '保存',
		cancel: 'キャンセル',
		InputIDExpirationDate: '証明書の有効期限を選択してください',
		saveSuccess: '正常に保存されました',
		saveFailed: '保存に失敗しました',
		reSave: 'もう一度保存してください',
		selectIDType: '書類の種類を選択してください',
		uploadIDpic: '証明写真をアップロードしてください',
		uploadIDbackPic: '身分証明書の裏面の写真をアップロードしてください',
		inputIDNumber: 'ID番号を入力してください',
		inputIDExpireDate: '証明書の発効日を選択してください',
		pleaseEnter: '入力してください',
		realNameCn: '中国語名を入力してください',
		realNameEn: '英語名を入力してください',
		realNameEnRule: '英字を入力してください。スペースは使用できません',
		enterPhoneNumber: '連絡先番号を入力してください',
		enterEmail: 'メールアドレスを入力してください',
		selectDOB: '生年月日を選択してください',
		errorDOB: '18 歳以上である必要があります',
		selectNation: '居住国を選択してください',
		enterAddressChinese: '中国の居住住所を入力してください',
		enterAddressEnglish: '英語の居住住所を入力してください',
		selectBussinessType: '会社の種類を選択してください',
		chinaId: '本土のIDカード',
		hongkongId: '香港のIDカード',
		passport: 'パスポート',
		permit: '本土旅行券',
		others: 'その他',
		companyCharter: '定款',
		otherstuff: 'その他の補足資料',
		companyCharterWarn: '会社定款をアップロードしてください',
		companyType: '会社の種類を選択してください',
		selectState: '州を選択してください',
		inputCity: '都市名を入力してください',
		selectContinent: '地域を選択',
		error1: '発効日は有効期限より後の日付にすることはできません',
		error2: '有効期限を発効日よりも前にすることはできません',
		error3: '何も操作しないと送信できません'
	},
	approveInfo: {
		menuList: ['会社情報', '法人情報', '株主情報', '役員情報', '実質的支配者情報', '変更履歴'],
		edit: '編集{name}',
		add: '{name} を追加',
		save: '保存してレビューのために送信する',
		saveWarning: '何も操作しないと送信できません',
		saveError: '少なくとも 1 つの {name} があります',
		cancel: '変更をキャンセルする',
		legal: {
			desc: '現在の法人は、'
		},
		director: {
			desc: '現在の株主は、',
			desc2: '現在の取締役は、'
		},
		beneficial: {
			desc: '現在の受取人は、'
		}
	},
	update: {
		time: '提出時間',
		type: '種類の変更',
		status: 'ステータス',
		operator: '担当者',
		modify: '改訂',
		improved: '改善すべき内容',
		go: 'に行く',
		forDetail: '書類の審査状況を確認する',
		edit: '埋める'
	},
	status: {
		pending: '審査中',
		modify: '修正予定',
		passed: '審査通過'
	},
	success: {
		title: '実名情報が送信されました。引き続きウェブサイトを追加してください。',
		tips: ['審査は事前販売審査後 5 ～ 7 営業日で完了します。レビューの進捗状況については、営業担当者に問い合わせてください。', ''],
		btn: 'サイトの追加を開始する'
	},
	changePerson: {
		toHistory: '送信後にレビューの進行状況を確認する必要がある場合は、<a href="/aq/certification?type=updateHistory" style="color:#1fa0e8;display:inline">[変更記録]</a> で確認してください。',
		changeTo: 'オブジェクトの変更',
		addLegalTip: '提出して承認されると、その法人は自動的に元の法人に置き換わります。',
		addLegal: '新しい法人を追加する',
		existDirector: '既存株主（削除可能、編集不可）',
		addDirectorTip: '新しい株主を追加する',
		addDirector: '株主を追加する',
		existBeneficial: '既存の受益者 (削除可能、編集不可)',
		addBeneficialTip: '新しい受益者を追加するには、株式の 25% 以上を保有する自然人株主の情報を入力してください。',
		addBeneficial: '実質的支配者を追加'
	},
	uploadError: '请上传{name}相关文件'
}
export default ja
